import { Link } from "react-router-dom"
import "./footer.css"

export default function Footer(){
    return(
        <section className="footer">
            <main>
                <div className="footerLogos">
                    <figure className="footerLogo">
                        <img src="../images/footerLogo.svg" alt="Travel Wise"/>
                    </figure>
                    <div>
                        <figure>
                            <img src="../images/fb.svg" alt="fb"/>
                        </figure>
                        <figure>
                            <img src="../images/ig.svg" alt="ig"/>
                        </figure>
                        <figure>
                            <img src="../images/x.svg" alt="x"/>
                        </figure>
                        <figure>
                            <img src="../images/yt.svg" alt="yt"/>
                        </figure>
                        <p>Follow Our Socials</p>
                    </div>
                </div>
                <div className="footerContact">
                    <aside>
                        <div>
                            <p className="title" style={{color:"grey"}}>Phone</p>
                            <a className="detail" style={{color:"white"}} href="tel:7357356060">735&nbsp;735&nbsp;6060</a><br/>
                            <a className="detail" style={{color:"white"}} href="tel:9994377761">999&nbsp;437&nbsp;7761</a>
                            {/* <p className="detail">(219) 772-1832</p> */}
                        </div>
                    </aside>

                    <aside>
                        <div>
                            <p className="title" style={{color:"grey"}}>Email</p>
                            <a className="detail" style={{color:"white"}} href="mailto:travelwiseindia@gmail.com">travelwiseindia@gmail.com</a>
                            {/* <a className="detail" href="mailto:supp.tour@example.com">supp.tour@example.com</a> */}
                        </div>
                    </aside>

                    <aside>
                        <div>
                            <p className="title" style={{color:"grey"}}>Address</p>
                            <p className="detail" style={{color:"white"}}>No.1/52, Babu Rao Street,</p>
                            <p className="detail" style={{color:"white"}}>(Near C.M.C Hospital),</p>
                            <p className="detail" style={{color:"white"}}>Vellore - 632004. Tamil Nadu</p>
                        </div>
                    </aside>
                </div>
            </main>
            <aside className="footerMenu">
                <div>
                    <p className="title" style={{color:"grey"}}>Working Hours</p>
                    <p className="detail" style={{color:"white", marginBottom:".5rem"}} >Mon&nbsp;-&nbsp;Sat &emsp;&emsp; 10.00AM&nbsp;-&nbsp;08.00PM</p>
                    <p className="detail" style={{color:"white"}} >Sunday Holiday</p>
                </div>
                <div>
                    <p className="title" style={{color:"grey"}}>Pages</p>
                    <ul>
                        <li><Link to={"/"}>Home</Link></li>
                        <li><Link to={"/about"}>About</Link></li>
                        <li><Link to={"/destination"}>Destination</Link></li>
                        <li><Link to={"/contact"}>Contact</Link></li>
                    </ul>
                </div>
            </aside>
            <p style={{color:"grey", fontSize:"12px"}}>@trulle</p>
        </section>
    )
}